import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Dokumentatsioon

  <span style="color:#85c1dc;">**FI:**</span>
  Dokumentointi

  <span style="color:#85c1dc;">**RU:**</span>
  Документация
*/
/* @__NO_SIDE_EFFECTS__ */
const m1195 = msg(
  mf`Dokumentatsioon`,
  mf`Dokumentointi`,
  mf`Документация`,
)

export { m1195 as 'w.module.product_description.product_file' }